import React from 'react';
import { TripStatus } from '../../helpers/fixcodes';
import { formatDate } from '../../helpers/globalfunctions';

// --- Pure renderers (no callbacks needed) ---

export function renderReatAtTimeCell(data) {
    if (data.data.dataRead === null || data.data.dataRead === false) {
        return <span className="notif-unread-badge"><i className="fas fa-circle"></i> Unread</span>;
    }
    return (
        <span className="notif-read-time">
            <i className="fas fa-check-circle"></i> {formatDate(data.data.readAt, "MM/dd/yyyy hh:mm")}
        </span>
    );
}

export function renderChangeTypeCell(data) {
    const type = (data.data.changeType || '').toLowerCase();
    let cls = 'notif-change-badge notif-change-default';
    if (type.includes('flight time') || type.includes('flighttime')) cls = 'notif-change-badge notif-change-flighttime';
    else if (type.includes('pickup') || type.includes('pick')) cls = 'notif-change-badge notif-change-pickup';
    else if (type.includes('cancel')) cls = 'notif-change-badge notif-change-cancel';
    else if (type.includes('assign')) cls = 'notif-change-badge notif-change-assign';
    else if (type.includes('new') || type.includes('add')) cls = 'notif-change-badge notif-change-new';
    return <span className={cls}>{data.data.changeType}</span>;
}

export function renderPickupTimeCell(data) {
    //if (data.data.pickupTimeChange === true) {
    if (data.data.isPickupTimeChange === true) {    
        return <div className="flightTimeTextColor">&nbsp;&nbsp;{formatDate(data.data.pickupDateTime, "MM/dd/yyyy hh:mm")}</div>;
    }
    return <div>{formatDate(data.data.pickupDateTime, "MM/dd/yyyy hh:mm")}</div>;
}

export function renderDeBriefingCell(data) {
    //if (data.data.deBriefingTime !== null && data.data.debriefingTimeChange === true) {
    if (data.data.deBriefingTime !== null && data.data.isDebriefingTimeChange === true) {        
        return <div className="reportTimeTextColor">&nbsp;&nbsp;{formatDate(data.data.deBriefingTime, "MM/dd/yyyy hh:mm")}</div>;
    }
    else if (data.data.deBriefingTime !== null && data.data.isDebriefingTimeChange === false) {        
        return <div>&nbsp;&nbsp;{formatDate(data.data.deBriefingTime, "MM/dd/yyyy hh:mm")}</div>;
    }
    return <div>{data.data.deBriefingTime}</div>;
}

// Renders the combined "D : <deBriefingTime>" / "R : <dutyReportingTime>" text built by the
// custom grid's calculateCellValue, highlighting it when the time shown has changed.
export function renderReportingDeBriefingCell(data) {
    const r = data.data;
    const isChanged = r.deBriefingTime ? r.isDebriefingTimeChange === true : r.isDutyReportTimeChange === true;
    return <div className={isChanged ? 'reportTimeTextColor' : undefined}>{data.value}</div>;
}

// --- Renderers that require a callback ---

export function renderEtaEtdCell(data, onUpdateEtaEtd) {
    const showLink = [
        parseInt(TripStatus.DRIVERACCEPTED),
        parseInt(TripStatus.VEHICLEASSIGNED),
        parseInt(TripStatus.ONLOCATION),
        parseInt(TripStatus.PAXLOAD),
        parseInt(TripStatus.PAXUNLOAD),
    ].includes(parseInt(data.data.tripStatusId));

    const link = showLink
        ? <a href="#" className="text-info" title={data.data.etaEtdMessage} onClick={(e) => onUpdateEtaEtd(e, data.data)}>{data.data.vehicleEtaEtd}</a>
        : null;

    return <div>{link}&nbsp;&nbsp;&nbsp;&nbsp;</div>;
}

export function renderReatNotificationCell(data, onReadNotification) {
    if (data.data.dataRead === null || data.data.dataRead === false) {
        return (
            <button className="notif-read-btn" title="Mark as Read" onClick={(e) => onReadNotification(e, data.data)}>
                <i className="fas fa-check"></i> Read
            </button>
        );
    }
    return <i className="fas fa-check-double notif-done-icon" title="Already Read"></i>;
}

export function renderPickupAddressCell(data, onShowPopup) {
    const address = data.data.puStreet || '';
    const icon = (
        <a href="#" className="address-popup-icon" title="View full address"
            onClick={(e) => onShowPopup(e, address, 'Pick-up Address')}>
            <i className="fas fa-map-marker-alt"></i>
        </a>
    );
    if (data.data.crewAddressChange === true && data.data.rideTypeId === 2) {
        return <div className="crewAddressTextColor address-cell" title={address}>{icon}&nbsp;&nbsp;{address}</div>;
    }
    return <div className="address-cell" title={address}>{icon}&nbsp;{address}</div>;
}

export function renderDropoffAddressCell(data, onShowPopup) {
    const address = data.data.doStreet || '';
    const icon = (
        <a href="#" className="address-popup-icon" title="View full address"
            onClick={(e) => onShowPopup(e, address, 'Drop-off Address')}>
            <i className="fas fa-map-marker-alt"></i>
        </a>
    );
    if (data.data.crewAddressChange === true && data.data.rideTypeId === 1) {
        return <div className="crewAddressTextColor address-cell" title={address}>{icon}&nbsp;&nbsp;{address}</div>;
    }
    return <div className="address-cell" title={address}>{icon}&nbsp;{address}</div>;
}

const NON_FLY_ICON_STYLE = {
    width: 18,
    height: 18,
    objectFit: 'contain',
    borderRadius: 3,
    verticalAlign: 'middle',
};

export function renderFlightInfoCell(data) {
    if (data.data.activityTypeId !== 2) {
        return (
            <span>
                <img src={data.data.airlineLogoUrl} className="img-icon" onError={(e) => { e.target.src = '../dist/img/icon/ico_NoAirline.png'; }} />
                &nbsp;{data.data.flightInfo}
            </span>
        );
    }
    return (
        <span>
            {/* Detailed square logo (solid background, no transparency) that is unreadable at the shared
                12px .img-icon size, so it gets its own larger rounded style. The size is also set inline so
                the icon stays cell-sized even when a cached customstyle.css lacks .img-icon-nonfly.
                onError just hides it: falling back to the same URL would retry forever if the file were missing. */}
            <img src="../dist/img/icon/ground_duty.png" className="img-icon-nonfly" style={NON_FLY_ICON_STYLE} alt="Non-flying activity" title="Non-flying activity" onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; }} />
            &nbsp;{data.data.flightInfo}
        </span>
    );
}

export function renderJobIdCell(data) {
    if (data.data.jobId > 0 && data.data.clubbedCount > 1) {
        return <span>{data.data.jobId}</span>;
    }
    return <span>&nbsp;</span>;
}

export function renderPaxNameCell(data) {
    if (data.data.hasAttachment === true) {
        return (
            <span>
                <i className="fa fa-paperclip text-danger" aria-hidden="true"></i>
                &nbsp;&nbsp;{data.data.paxName}
            </span>
        );
    }
    return <span>{data.data.paxName}</span>;
}
